import { render, staticRenderFns } from "./CompanyNameCost.vue?vue&type=template&id=496e888a&scoped=true"
import script from "./CompanyNameCost.vue?vue&type=script&lang=js"
export * from "./CompanyNameCost.vue?vue&type=script&lang=js"
import style0 from "./CompanyNameCost.vue?vue&type=style&index=0&id=496e888a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e888a",
  null
  
)

export default component.exports